module.exports = __webpack_public_path__ + "static/ebapp-111b725ab6ddadd2686684176aad054d.jpg";